import { render, staticRenderFns } from "./SupplierInfo.vue?vue&type=template&id=7b34ebc4&scoped=true&"
import script from "./SupplierInfo.vue?vue&type=script&lang=js&"
export * from "./SupplierInfo.vue?vue&type=script&lang=js&"
import style0 from "./SupplierInfo.vue?vue&type=style&index=0&id=7b34ebc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b34ebc4",
  null
  
)

export default component.exports